import Watcher from './Watcher';
import WatchedData from './WatchedData';

export default class Watchable {
  _watcher = null;

  addWatcher(/* Watcher */ watcher) {
    if (!watcher instanceof Watcher) {
      throw new Error('watcher must be an instance of Watcher');
    }
    this._watcher = watcher;
  }

  notifyWatcher(/* WatchedData */ data) {
    if (!data instanceof WatchedData) {
      throw new Error('data must be an instance of WatchedData');
    }

    /*
    Sometimes data will not be settled in state or otherwise when this happens. We rely
    on the watcher to delay these calls in batches to avoid this problem.
     */
    if (!this._watcher) return;
    this._watcher.notify(this, data);
  }
}
